import React, { useEffect } from 'react'
import Header from "../../../components/User/Header/Header"
import Footer from "../../../components/User/Footer/Footer"

function UnaccompaniedBaggage() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

    return (
        <div className="page-wrapper">
          <Header />
          {/* Hero Section  */}
          <section
            class="call-to-action-one sp-four"
            //   style={{ backgroundImage: `url(${HomeBanner})` }}
          >
            <div class="container">
              <div class="sec-title-one white text-center">
                <h2>Sending Unaccompanied Baggage with ease</h2>
              </div>
            </div>
          </section>
          <section className="why-chooseus sp-four">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-md-12 col-sm-12">
                  <div className="choose-left-content">
                    <div className="sec-title-one">
                      {/* <h5>Our Qualification</h5> */}
                      <h2>
                        <span>The Pleasure of care free </span>
                        <br />and hassle free travelling.
                      </h2>
                    </div>
                    <div className="text mt-45">
                      <p>
                      Keeping in mind the airline’s restrictive weight allowances you are left with two options, one is to pay the high excess baggage charges or to leave behind many of the personal belongings that you had intended to take along. Whether you are living abroad for a job, or studying in other country, or relocating country with family, or even planning a holiday with your family; then sending your baggage ahead separately would be much more convenient and affordable.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 col-sm-12">
                  <div className="choose-right-area">
                    <figure>
                      <img
                        src={require("../../../images/resource/shoose-us-1.jpg")}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12 col-md-12 col-sm-12">
                  <div className="choose-left-content">
                    <div className="text mt-45">
                      <p>
                       With Carrymybaggage there is no more dragging and hauling of baggage through airports, our expert baggage shipping service helps you save time and energy. Carrymybaggage is a great alternative to the extortionate unaccompanied baggage charges. Carrymybaggage enables you to ship your baggage at a comparatively lower rate which is both economical and affordable. With Carrymybaggage you never have to worry about the safety of your personal belongings as our team is extensively careful while handling your baggage.
                      </p>
                      <p>
                      Sending unaccompanied baggage with Carrymybaggage is fast and easy. Our online booking system enables you to get a quick quotation of charges and you can get started with just a click. When you book with Carrymybaggage you are guaranteed of minimal costing and convenient services with fast and safe transit of your baggage.
                      </p>
                      <p>
                      Carrymybaggage team comprises of young passionate professionals who know their duties well and completely understand the complexities of travelling overseas. So, we at Carrymybaggage make it our top priority to make our customer’s travelling experience as comfortable and convenient as possible.
                      </p>
                      <p>
                      Carrymybaggage provides a hassle free door to door baggage shipping service worldwide. There’s no need for you to bring your baggage at a drop off nor do you need to look out for your belongings at the other side. Our door to door collection and delivery services save you from all the stress and hassle.
                      </p>
                      <p>
                      Get a quick quote online with detailed estimation of charges, computerised inventory and description of packaging and transportation used. All our services are handled by professionally trained staff right from the point of collection to the point of delivery. Our convenient online tracking system keeps you updated and you can know where exactly your shipment is. Our services are transparent without any hidden charges.
                      </p>
    
                      <p>
                      Get a quick quote online with detailed estimation of charges, computerised inventory and description of packaging and transportation used. All our services are handled by professionally trained staff right from the point of collection to the point of delivery. Our convenient online tracking system keeps you updated and you can know where exactly your shipment is. Our services are transparent without any hidden charges.
                      Choose Carrymybaggage to send your unaccompanied excess baggage and pack heavy, travel light.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      );
}

export default UnaccompaniedBaggage